<template>
  <div class="card mb-3">
    <div class="card-header">
      <i class="fa fa-briefcase"></i> {{ $t('partner.title') }}
      <createButton name="partners_create" :title="$t('partner.create.title')"></createButton>
      <createButton name="coinvestor_create" :title="$t('partner.coinvestor.create.title')"></createButton>
    </div>
    <div class="card-body">
      <errorMessage v-bind:message="error"></errorMessage>
      
      <div class="table-responsive">
        <table class="table table-bordered table-striped" id="dataTable" width="100%" cellspacing="0">
          <thead>
            <tr>
              <th class="export">{{ $t('partner.form.id') }}</th>
              <th>{{ $t('partner.form.name') }}</th>
              <th class="drop-down-filter">{{ $t('partner.form.plan') }}</th>
              <th class="export">{{ $t('address.title') }}</th>
              <th class="export">{{ $t('partner.form.implication.adhesion') }}</th>
              <th class="export">{{ $t('partner.form.implication.annulation') }}</th>
              <th class="export">{{ $t('partner.form.implication.annulationReason') }}</th>
              <th class="no-sort not-export no-filter" v-if="canCreate || canDelete">&nbsp;</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th class="export">{{ $t('partner.form.id') }}</th>
              <th>{{ $t('partner.form.name') }}</th>
              <th class="drop-down-filter">{{ $t('partner.form.plan') }}</th>
              <th class="export">{{ $t('address.title') }}</th>
              <th class="export">{{ $t('partner.form.implication.adhesion') }}</th>
              <th class="export">{{ $t('partner.form.implication.annulation') }}</th>
              <th class="export">{{ $t('partner.form.implication.annulationReason') }}</th>
              <th class="no-sort not-export no-filter" v-if="canCreate || canDelete">&nbsp;</th>
            </tr>
          </tfoot>
          <tbody>
            <tr v-for="partner in entites" :key="partner.id" v-bind:data-id="partner.id" @click="view(partner)" class="clickable-row">
              <td>{{partner.id}}</td>
              <td>{{partner.name}}</td>
              <td>{{partner.planText}}</td>
             
              <td>{{ partner.address | addressFormat }}</td>

              <td>{{ partner.adhesion | formatDate }}</td>
              <td>{{ partner.annulation | formatDate }}</td>
              <td>{{ partner.annulationReasonText }}</td>

              <td class="no-sort" align="center" v-if="canCreate || canDelete">
                <a href="#" v-if="canCreate" v-bind:title="$t('form.edit_button')" v-on:click.stop="edit(partner)">
                  <span class="fa fa-lg fa-pencil"></span>
                </a>
                &nbsp;
                <a  href="#" v-if="canCreate" v-bind:title="$t('form.copy_button')" v-on:click.stop="copy(partner)">
                  <span class="fa fa-lg fa-copy"></span>
                </a>
                &nbsp;
                <a class="text-danger" v-if="canDelete" v-bind:title="$t('form.delete_button')" href="#" v-on:click.stop="deleteEntity(partner)">
                  <span class="fa fa-lg fa-trash"></span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {PartnerServiceClient} from '../../shared/service-clients/service-clients'
import SearchMixin from '../../shared/Mixin/SearchMixin'
import moment from 'moment'

export default {
  name: 'Partners',
  mixins: [SearchMixin],
  data() {
    return {
      serviceClient: PartnerServiceClient,
    }
  },
  methods: {
    edit: function(partner) {
      let action = 'edit'
      this.redirect(partner, action)
    },
    view: function(partner) {
      let action = 'view'
      this.redirect(partner, action)
    },
    copy: function(partner) {
      let action = 'copy'
      this.redirect(partner, action)
    },
    redirect: function(partner, action) {
      let name = this.name
      if (partner.plan == 6) name = 'coinvestor'

      this.$router.push({name: name + '_' + action, params: {id: partner.id}})
    },
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>




// WEBPACK FOOTER //
// src/components/partners/Partners.vue